import NavDashboard from "../Navigation/NavDashboard";
import PropTypes from "prop-types";

const HomeContentContainer = ({ children }) => {
  return (
    <div className="w-full min-h-screen background-page-color">
      <NavDashboard />
      <div className="pb-25 pt-4 sm:pb-4 md:pb-6 px-2 sm:px-4 md:px-6 flex flex-col lg:flex-row gap-2 overflow-auto w-screen sm:w-auto">
        {children}
      </div>
    </div>
  );
};

HomeContentContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HomeContentContainer;
